export default {
  emits: ['addTimeline', 'updateTimeline', 'removeTimeline', 'pinTimeline'],
  methods: {
    /* Add Note */
    async baseAddNote (note, done, id, timeline, emitEvent = false) {
      const { status, payload } = await this.$post('v1/business/company/licences/notes', {
        id,
        value: note.value,
        is_hidden: false
      })
      if (status === 'success') {
        timeline.unshift(payload.notes[0])
        if (emitEvent) {
          this.$emit('addTimeline', payload.notes[0])
        }
        done()
      }
    },
    /* Update Note */
    async baseUpdateNote (note, done, emitEvent = false) {
      const { status } = await this.$put('v1/business/company/licences/notes', {
        id: note.id,
        value: note.value
      })
      if (status === 'success') {
        if (emitEvent) {
          this.$emit('updateTimeline', note)
        }
        done()
      }
    },
    /* Remove Note */
    async baseRemoveNote (id, reference, emitEvent = false) {
      const { status } = await this.$remove('v1/business/company/licences/notes', {
        id
      })
      if (status === 'success') {
        if (emitEvent) {
          this.$emit('removeTimeline', reference)
        }
      }
    },
    /* Save Attachments */
    async baseSaveAttachments (keepIds, removeObjs, done, id, timeline, emitEvent = false) {
      const { status, payload } = await this.$post('v1/business/company/licences/attachments', {
        id,
        files: keepIds
      })
      if (status === 'success') {
        timeline.unshift(...payload.files)
        if (emitEvent) {
          this.$emit('addTimeline', payload.files)
        }

        // Remove entries from the timeline
        for (const ele of removeObjs) {
          timeline.splice(timeline.indexOf(ele), 1)
          if (emitEvent) {
            this.$emit('removeTimeline', ele.timeline_reference)
          }
        }
        done()
      }
    },
    /* Remove Attachment */
    async baseRemoveAttachment (id, key, modelId, reference, emitEvent = false) {
      const { status } = await this.$remove('v1/business/company/licences/attachments', {
        model_id: modelId,
        id,
        key
      })
      if (status === 'success') {
        if (emitEvent) {
          this.$emit('removeTimeline', reference)
        }
      }
    }
  }
}
